import { useState } from "react";
import { fixSteps } from "@/mocks/home";
import SectionHeading from "@/components/feature/SectionHeading";

export default function FixGuide() {
  const [openId, setOpenId] = useState(fixSteps[0].id);

  return (
    <section id="fix" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4">
        <SectionHeading
          eyebrow="分步解决方法"
          title="按顺序试一试，多半能打开"
          desc="下面 7 步从最简单、成功率最高的开始。一般做到前两步就能解决大部分问题，实在不行再往后逐条排查。点击标题可以展开查看详细说明。"
        />

        <div className="flex flex-col gap-3">
          {fixSteps.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className={
                  isOpen
                    ? "overflow-hidden rounded-lg border border-primary-300 bg-background-50"
                    : "overflow-hidden rounded-lg border border-background-200 bg-background-50"
                }
              >
                <button
                  type="button"
                  onClick={() => setOpenId(isOpen ? "" : item.id)}
                  aria-expanded={isOpen}
                  className="flex w-full cursor-pointer items-center gap-4 p-4 text-left md:p-5"
                >
                  <span
                    className={
                      isOpen
                        ? "flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50"
                        : "flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-background-100 font-heading text-sm font-bold text-foreground-700"
                    }
                  >
                    {item.step}
                  </span>
                  <span className="flex-1 font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {item.title}
                  </span>
                  <i
                    className={
                      isOpen
                        ? "ri-subtract-line text-xl text-primary-600"
                        : "ri-add-line text-xl text-foreground-400"
                    }
                  ></i>
                </button>

                <div className="px-4 pb-5 pl-[72px] pr-4 md:px-5">
                  <p className="text-sm leading-relaxed text-foreground-600">
                    {item.desc}
                  </p>
                  <p className="mt-3 inline-flex items-start gap-2 rounded-md bg-primary-50 px-3 py-2 text-xs leading-relaxed text-primary-800">
                    <i className="ri-lightbulb-line mt-0.5"></i>
                    小提示：{item.tip}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}